export default {"src":"/_next/static/media/target-tab-hi.d28a2b3a.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};